import {Fragment} from "react";

import "nouislider/dist/nouislider.css";
import "jsvectormap/dist/jsvectormap.min.css";

// import './assets/scss/Default.scss';
// import "./assets/scss/Icons.scss";

// import configureFakeBackend from "./helpers/fake-backend";
import AllRoutes from "./routes/Routes";
import AppProvidersWrapper from "./components/AppProvidersWrapper";
import React from "react";
import { ToastContainer } from "react-toastify";

// configureFakeBackend();

function App() {

    return (
        <>
            <Fragment>
                <AppProvidersWrapper>
                    <AllRoutes/>
                    <ToastContainer />
                </AppProvidersWrapper>
            </Fragment>


        </>
    )
}

export default App
